export default "__VITE_ASSET__FCh9T8iQ__"